import React, { useState } from "react";
import { Alert, CircularProgress, Grid, } from "@mui/material";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

export default function CareersForm() {
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: "", message: "" });
    const [form, setForm] = useState({
        nome: "",
        email: "",
        telefone: "",
        cidade: "",
        areaInteresse: "",
        experiencia: "",
        linkedin: "",
        mensagem: "",
        arquivo: null,
        consent: false,
    });

    const onChange = (e) => {
        const { name, value, type, checked, files } = e.target;
        if (type === "file") setForm((p) => ({ ...p, arquivo: files?.[0] || null }));
        else if (type === "checkbox") setForm((p) => ({ ...p, [name]: checked }));
        else setForm((p) => ({ ...p, [name]: value }));
    };

    const validar = () => {
        const { nome, email, telefone, consent } = form;
        if (!nome || !email || !telefone) return "Preencha os campos obrigatórios.";
        if (!consent) return "É necessário aceitar o consentimento (LGPD).";
        return "";
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setStatus({ type: "", message: "" });

        const err = validar();
        if (err) return setStatus({ type: "error", message: err });

        setLoading(true);

        try {
            const payload = {
                nome: form.nome,
                email: form.email,
                telefone: form.telefone,
                cidade: form.cidade,
                areaInteresse: form.areaInteresse,
                experiencia: form.experiencia,
                linkedin: form.linkedin,
                mensagem: form.mensagem,
                assunto: "Trabalhe Conosco - Ramlis Machine",
            };

            console.log("JSON enviado:", payload);

            const resp = await fetch("https://ramlismachine.com.br/api/sendmail.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });

            const data = await resp.json();
            if (!resp.ok || !data.success)
                throw new Error(data.message || `Erro HTTP ${resp.status}`);

            setStatus({
                type: "success",
                message: "Currículo enviado com sucesso! Entraremos em contato em breve.",
            });

            setForm({
                nome: "",
                email: "",
                telefone: "",
                cidade: "",
                areaInteresse: "",
                experiencia: "",
                linkedin: "",
                mensagem: "",
                consent: false,
            });
        } catch (e2) {
            console.error("Erro ao enviar:", e2);
            setStatus({
                type: "error",
                message:
                    e2?.message ||
                    "Não foi possível enviar. Tente novamente mais tarde.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={onSubmit} style={{ padding: 24 }}>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <MKInput label="Nome Completo" name="nome" value={form.nome} onChange={onChange} required fullWidth autoComplete="name" />
                </Grid>
                <Grid item xs={12} md={6}>
                    <MKInput type="email" label="E-mail" name="email" value={form.email} onChange={onChange} required fullWidth autoComplete="email" />
                </Grid>
                <Grid item xs={12} md={6}>
                    <MKInput
                        label="Telefone"
                        name="telefone"
                        value={form.telefone}
                        onChange={onChange}
                        required
                        fullWidth
                        placeholder="(11) 99999-9999"
                        inputProps={{ inputMode: "tel", pattern: "[0-9()+\\-\\s]{8,}" }}
                        autoComplete="tel"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <MKInput label="Cidade/UF" name="cidade" value={form.cidade} onChange={onChange} fullWidth />
                </Grid>

                <Grid item xs={12}>
                    <MKInput
                        label="Perfil do LinkedIn (opcional)"
                        name="linkedin"
                        value={form.linkedin}
                        onChange={onChange}
                        fullWidth
                        placeholder="https://www.linkedin.com/in/seuperfil"
                    />
                </Grid>
                <Grid item xs={12}>
                    <MKInput
                        multiline
                        rows={4}
                        label="Currículo/Mensagem/Carta de Apresentação"
                        name="mensagem"
                        value={form.mensagem}
                        onChange={onChange}
                        fullWidth
                        placeholder="Conte um pouco sobre você, suas experiências e por que deseja trabalhar conosco..."
                    />
                </Grid>
                {/* <Grid item xs={12}>
                    <MKTypography variant="button" color="text">Currículo (PDF/DOC/DOCX)*</MKTypography>
                    <div style={{ marginTop: 8 }}>
                        <input
                            id="arquivo"
                            name="arquivo"
                            type="file"
                            accept=".pdf,.doc,.docx"
                            onChange={onChange}
                            required
                            style={{ display: "block", width: "100%" }}
                        />
                        <MKTypography variant="caption" color="text">Tamanho máximo: {MAX_SIZE_CV_MB} MB.</MKTypography>
                    </div>
                </Grid> */}
                <Grid item xs={12}>
                    <label
                        style={{
                            display: "flex",
                            alignItems: "flex-start",
                            columnGap: 8,
                            flexWrap: "nowrap",
                        }}
                    >
                        <input
                            type="checkbox"
                            name="consent"
                            checked={form.consent}
                            onChange={onChange}
                            required
                            style={{
                                marginTop: 2,
                                width: "auto",
                                display: "inline-block",
                                flex: "0 0 auto",
                            }}
                        />
                        <MKTypography variant="caption" color="text" sx={{ lineHeight: 1.4 }}>
                            Autorizo o tratamento dos meus dados para fins de recrutamento e seleção (LGPD).
                        </MKTypography>
                    </label>
                </Grid>

                {status.message && (
                    <Grid item xs={12}>
                        <Alert severity={status.type === "success" ? "success" : "error"}>
                            {status.message}
                        </Alert>
                    </Grid>
                )}

                <Grid item xs={12} display="flex" gap={1.5} alignItems="center">
                    <MKButton type="submit" variant="gradient" color="info" disabled={loading}>
                        {loading ? (
                            <>
                                <CircularProgress size={18} color="inherit" style={{ marginRight: 8 }} />
                                Enviando…
                            </>
                        ) : "Enviar Currículo"}
                    </MKButton>
                </Grid>
            </Grid>
        </form>
    );
}